<template>
  <!-- Applied `v-icon__svg` class to <svg> in icon component to change the color, see https://stackoverflow.com/a/75694932/4673960 -->
  <v-icon class="font-weight-black" :color="color">{{ icon }}</v-icon>
</template>

<script>

export default {
  name: 'EventIcon',
  props: {
    value: {
      type: String,
      required: true
    }
  },
  data: () => ({
  }),
  computed: {
    color() {
      return this.value === 'ARRIVAL' ? 'blue lighten-2' : 'purple darken-2'
    },
    icon() {
      return this.value === 'ARRIVAL' ? 'mdi-arrow-bottom-right-thick' : 'mdi-arrow-top-right-thick'
    }
  },
  methods: {
  }
}
</script>
